// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { listClasses } from '@mui/material/List';
import { listItemClasses } from '@mui/material/ListItem';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { listColors } from './listColors';
export var List = function(mode) {
    var colors = listColors(mode);
    var _obj, _obj1;
    var override = {
        MuiList: {
            styleOverrides: {
                root: {
                    padding: 0
                }
            }
        },
        MuiListItem: {
            styleOverrides: {
                root: _define_property({
                    gap: rem(8)
                }, "&.".concat(listItemClasses.dense), {
                    gap: rem(4)
                }),
                // Padding belongs in the `padding` slot rather than `root`: MUI only applies
                // this slot when `disablePadding` is false. Horizontal padding is further
                // scoped to the `gutters` class so `disableGutters` drops it.
                padding: (_obj = {
                    paddingTop: rem(8),
                    paddingBottom: rem(8)
                }, _define_property(_obj, "&.".concat(listItemClasses.gutters), {
                    paddingLeft: rem(8),
                    paddingRight: rem(8)
                }), _define_property(_obj, "&.".concat(listItemClasses.dense), _define_property({
                    paddingTop: rem(4),
                    paddingBottom: rem(4)
                }, "&.".concat(listItemClasses.gutters), {
                    paddingLeft: rem(4),
                    paddingRight: rem(4)
                })), _obj)
            }
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: (_obj1 = {}, // Scoped to a real `ListItem` ancestor (Figma node 12180-2846) so this
                // doesn't leak into MenuItem, which renders ListItemIcon as a direct child
                // without a ListItem wrapper and has its own icon spec (see Menu.tsx).
                _define_property(_obj1, ".".concat(listItemClasses.root, " &"), _define_property({
                    minWidth: 'unset',
                    color: colors.icon,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(20)
                })), _define_property(_obj1, ".".concat(listItemClasses.root, ".").concat(listItemClasses.dense, " &"), _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(12)
                })), _obj1)
            }
        },
        MuiListSubheader: {
            styleOverrides: {
                root: _define_property({
                    backgroundColor: colors.subheaderBackground.level0,
                    padding: "".concat(rem(4), " ").concat(rem(8)),
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    fontWeight: 500,
                    color: colors.secondaryText
                }, ".".concat(listClasses.dense, " &"), {
                    fontSize: rem(12),
                    lineHeight: rem(16)
                })
            },
            variants: [
                {
                    props: {
                        backgroundColor: 'level0'
                    },
                    style: {
                        backgroundColor: colors.subheaderBackground.level0
                    }
                },
                {
                    props: {
                        backgroundColor: 'level50'
                    },
                    style: {
                        backgroundColor: colors.subheaderBackground.level50
                    }
                },
                {
                    props: {
                        backgroundColor: 'level100'
                    },
                    style: {
                        backgroundColor: colors.subheaderBackground.level100
                    }
                },
                {
                    props: {
                        backgroundColor: 'level200'
                    },
                    style: {
                        backgroundColor: colors.subheaderBackground.level200
                    }
                },
                {
                    props: {
                        backgroundColor: 'level300'
                    },
                    style: {
                        backgroundColor: colors.subheaderBackground.level300
                    }
                },
                {
                    props: {
                        backgroundColor: 'transparent'
                    },
                    style: {
                        backgroundColor: 'transparent'
                    }
                }
            ]
        },
        MuiListItemText: {
            styleOverrides: {
                root: _define_property({
                    margin: 0,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: rem(4)
                }, ".".concat(listItemClasses.dense, " &"), {
                    gap: 0
                }),
                primary: _define_property({
                    fontSize: rem(14),
                    lineHeight: rem(18),
                    color: colors.text
                }, ".".concat(listItemClasses.dense, " &"), {
                    fontSize: rem(12),
                    lineHeight: rem(16)
                }),
                secondary: _define_property({
                    fontSize: rem(12),
                    lineHeight: rem(16),
                    color: colors.secondaryText
                }, ".".concat(listItemClasses.dense, " &"), {
                    fontSize: rem(11),
                    lineHeight: rem(14)
                })
            }
        }
    };
    return override;
};

//# sourceMappingURL=List.js.map